/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountResponseDto } from './BankAccountResponseDto';
import {
    BankAccountResponseDtoFromJSON,
    BankAccountResponseDtoFromJSONTyped,
    BankAccountResponseDtoToJSON,
    BankAccountResponseDtoToJSONTyped,
} from './BankAccountResponseDto';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';
import type { BrokerResponseDto } from './BrokerResponseDto';
import {
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoFromJSONTyped,
    BrokerResponseDtoToJSON,
    BrokerResponseDtoToJSONTyped,
} from './BrokerResponseDto';
import type { ReceiptSettlementExchangeRateResponseDto } from './ReceiptSettlementExchangeRateResponseDto';
import {
    ReceiptSettlementExchangeRateResponseDtoFromJSON,
    ReceiptSettlementExchangeRateResponseDtoFromJSONTyped,
    ReceiptSettlementExchangeRateResponseDtoToJSON,
    ReceiptSettlementExchangeRateResponseDtoToJSONTyped,
} from './ReceiptSettlementExchangeRateResponseDto';

/**
 * 
 * @export
 * @interface ReceiptResponseDto
 */
export interface ReceiptResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ReceiptResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReceiptResponseDto
     */
    updatedAt: Date;
    /**
     * Receipt ID
     * @type {number}
     * @memberof ReceiptResponseDto
     */
    id: number;
    /**
     * Transaction date
     * @type {Date}
     * @memberof ReceiptResponseDto
     */
    transactionDate: Date;
    /**
     * Type of receipt
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    receiptType: ReceiptResponseDtoReceiptTypeEnum;
    /**
     * Bank account number
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    bankAccountNumber: string;
    /**
     * Receipt amount
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    amount: string;
    /**
     * Bank fee
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    bankFee?: string;
    /**
     * Receipt amount
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    remainingAmount: string;
    /**
     * Source broker ID
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    sourceBrokerId: string;
    /**
     * Free-text input for broker reference
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    sourceBrokerReference?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceiptResponseDto
     */
    comment?: string;
    /**
     * 
     * @type {BrokerResponseDto}
     * @memberof ReceiptResponseDto
     */
    sourceBroker?: BrokerResponseDto;
    /**
     * 
     * @type {BankAccountResponseDto}
     * @memberof ReceiptResponseDto
     */
    bankAccount: BankAccountResponseDto;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof ReceiptResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
    /**
     * 
     * @type {Array<ReceiptSettlementExchangeRateResponseDto>}
     * @memberof ReceiptResponseDto
     */
    settlementExchangeRates?: Array<ReceiptSettlementExchangeRateResponseDto>;
}


/**
 * @export
 */
export const ReceiptResponseDtoReceiptTypeEnum = {
    Premium: 'Premium',
    Claims: 'Claims',
    Other: 'Other'
} as const;
export type ReceiptResponseDtoReceiptTypeEnum = typeof ReceiptResponseDtoReceiptTypeEnum[keyof typeof ReceiptResponseDtoReceiptTypeEnum];


/**
 * Check if a given object implements the ReceiptResponseDto interface.
 */
export function instanceOfReceiptResponseDto(value: object): value is ReceiptResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('receiptType' in value) || value['receiptType'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('remainingAmount' in value) || value['remainingAmount'] === undefined) return false;
    if (!('sourceBrokerId' in value) || value['sourceBrokerId'] === undefined) return false;
    if (!('bankAccount' in value) || value['bankAccount'] === undefined) return false;
    return true;
}

export function ReceiptResponseDtoFromJSON(json: any): ReceiptResponseDto {
    return ReceiptResponseDtoFromJSONTyped(json, false);
}

export function ReceiptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'transactionDate': (new Date(json['transactionDate'])),
        'receiptType': json['receiptType'],
        'bankAccountNumber': json['bankAccountNumber'],
        'amount': json['amount'],
        'bankFee': json['bankFee'] == null ? undefined : json['bankFee'],
        'remainingAmount': json['remainingAmount'],
        'sourceBrokerId': json['sourceBrokerId'],
        'sourceBrokerReference': json['sourceBrokerReference'] == null ? undefined : json['sourceBrokerReference'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'sourceBroker': json['sourceBroker'] == null ? undefined : BrokerResponseDtoFromJSON(json['sourceBroker']),
        'bankAccount': BankAccountResponseDtoFromJSON(json['bankAccount']),
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
        'settlementExchangeRates': json['settlementExchangeRates'] == null ? undefined : ((json['settlementExchangeRates'] as Array<any>).map(ReceiptSettlementExchangeRateResponseDtoFromJSON)),
    };
}

export function ReceiptResponseDtoToJSON(json: any): ReceiptResponseDto {
    return ReceiptResponseDtoToJSONTyped(json, false);
}

export function ReceiptResponseDtoToJSONTyped(value?: ReceiptResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'id': value['id'],
        'transactionDate': ((value['transactionDate']).toISOString()),
        'receiptType': value['receiptType'],
        'bankAccountNumber': value['bankAccountNumber'],
        'amount': value['amount'],
        'bankFee': value['bankFee'],
        'remainingAmount': value['remainingAmount'],
        'sourceBrokerId': value['sourceBrokerId'],
        'sourceBrokerReference': value['sourceBrokerReference'],
        'comment': value['comment'],
        'sourceBroker': BrokerResponseDtoToJSON(value['sourceBroker']),
        'bankAccount': BankAccountResponseDtoToJSON(value['bankAccount']),
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
        'settlementExchangeRates': value['settlementExchangeRates'] == null ? undefined : ((value['settlementExchangeRates'] as Array<any>).map(ReceiptSettlementExchangeRateResponseDtoToJSON)),
    };
}

